/**
 * Handle API errors and format them consistently
 * Prioriza o campo 'error' que vem do backend (GlobalExceptionHandler)
 */
export function handleApiError(error: any): Error {
  if (error.response) {
    // Server responded with error status
    const apiError = error.response.data;
    
    // Try to extract the most specific error message
    let message = 'Ocorreu um erro';
    
    if (typeof apiError === 'string') {
      message = apiError;
    } else if (apiError?.error) {
      // Priorizar o campo 'error' que vem do backend
      message = apiError.error;
    } else if (apiError?.message) {
      message = apiError.message;
    } else if (apiError?.errors && Array.isArray(apiError.errors) && apiError.errors.length > 0) {
      // Handle validation errors array
      message = apiError.errors.map((e: any) => e.message || e).join(', ');
    } else if (error.response.statusText) {
      message = error.response.statusText;
    }
    
    const err = new Error(message);
    (err as any).status = error.response.status;
    (err as any).response = error.response;
    (err as any).details = apiError?.details;
    (err as any).data = apiError?.data;
    return err;
  } else if (error.request) {
    // Request made but no response received
    return new Error('Sem resposta do servidor. Verifique sua conexão.');
  } else {
    // Error in request setup
    return new Error(error.message || 'Ocorreu um erro inesperado');
  }
}
